var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('b-form-select',{attrs:{"options":_vm.options,"value-field":"choice_id","text-field":"choice"},on:{"change":_vm.handleChangeValue},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }